"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtvHash = gtvHash;
const factory_1 = require("./tree/factory");
const hash_1 = require("./tree/hash");
function gtvHash(value, merkleHashVersion) {
    const tree = (0, factory_1.buildTree)(value, merkleHashVersion);
    return (0, hash_1.calculateMerkleHash)(tree);
}
//# sourceMappingURL=index.js.map